import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get sales-reports List
export const getSalesReportList = createAsyncThunk(
  "getSalesReportList",
  async (
    {
      pageLimit,
      pageCount,
      sort_by,
      sort_direction,
      date_range,
      year,
      company,
      technician_earnings_page = "",
      technician_earnings_per_page = "",
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `sales-reports?page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&date_range=${date_range}&year=${year}&company=${company}&technician_earnings_page=${technician_earnings_page}&technician_earnings_per_page=${technician_earnings_per_page}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get sales-reports List
export const getServicesReportList = createAsyncThunk(
  "getServicesReportList",
  async (
    {
      pageLimit,
      pageCount,
      sort_by,
      sort_direction,
      date_range,
      year,
      company,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `service-reports?page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&date_range=${date_range}&year=${year}&company=${company}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// get company-service-reports
export const getCompanyReportList = createAsyncThunk(
  "getCompanyReportList",
  async (
    {
      pageLimit,
      pageCount,
      sort_by,
      sort_direction,
      date_range,
      year,
      service_page,
      service_limit,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-service-reports?page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&date_range=${date_range}&year=${year}&service_page=${service_page}&service_limit=${service_limit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// getCompanyViewServiceList
export const getCompanyViewServiceList = createAsyncThunk(
  "getCompanyViewServiceList",
  async (
    { service_page, service_limit, companyId, sort_by, sort_direction },

    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-service-reports/${companyId}?service_page=${service_page}&service_limit=${service_limit}&service_sort_by=${sort_by}&service_sort_direction=${sort_direction}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// outstanding-reports
export const getOutstandingReportList = createAsyncThunk(
  "getOutstandingReportList",
  async (
    { pageLimit, pageCount, sort_by, sort_direction, date_range, company },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `outstanding-reports?page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&date_range=${date_range}&company=${company}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const salesReportSlice = createSlice({
  name: "salesReport",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get sales-reports
      .addCase(getSalesReportList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesReportListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSalesReportList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getServicesReportList
      .addCase(getServicesReportList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServicesReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.getServicesReportListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getServicesReportList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getCompanyReportList
      .addCase(getCompanyReportList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompanyReportListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCompanyReportList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getCompanyViewServiceList
      .addCase(getCompanyViewServiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyViewServiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompanyViewServiceListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCompanyViewServiceList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getOutstandingReportList
      .addCase(getOutstandingReportList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOutstandingReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.getOutstandingReportListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getOutstandingReportList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = salesReportSlice;
export default reducer;
